<!--
 * @Description: 图片拍照组件

 * @Version: 1.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <div class="comp-xl-img-wate">
    <div class="img-title">
      {{ $t('本字段只支持移动端拍照上传') }} <span class="title">({{ fileList?.length || 0 }}/{{ fieldExt?.limit || 0 }})</span>
    </div>
    <template v-if="fileList?.length > 0">
      <div class="attachments-preview-list">
        <span class="attach-item" v-for="(item, index) of fileList" :key="index" @click.stop>
          <fh-attachment-preview :file-item="item" :show-video-cover="true" :icon-style="iconStyle" :index="index" :list="fileList" />
          <div class="preview-content">
            <jw-tooltip :content="$t('预览')">
              <jw-link class="preview-link" :href="setLink(fileItem)" :target="setTarget(fileItem)" @click="openPreview(item, index)"> <qfei-icon-view-outlined /> </jw-link>
            </jw-tooltip>
            <jw-tooltip :content="$t('删除')">
              <span class="preview-link delete-link">
                <qfei-icon-close-one-outlined @click="deleteImg(item)" v-if="showRemoveBtn" />
              </span>
            </jw-tooltip>
            <jw-tooltip :content="$t('下载')">
              <span class="preview-link">
                <qfei-icon-download-outlined @click="handleDownload(fileItem)" />
              </span>
            </jw-tooltip>
          </div>
        </span>
      </div>
    </template>
  </div>
  <template v-if="visible">
    <fh-preview-modal ref="previewModalRef" :index="getFileIndex" :list="fileList" :active-file="getFileItem" />
  </template>
</template>

<script setup>
import { computed, ref, watch, nextTick } from 'vue';
import { tools } from '@/utils/tools.js';
import useXlUpload from '@/hooks/upload';
const { checkInvalidUrl, setUrl, getFileType, downloadFile } = useXlUpload();

import { useGrayscaleStore } from '@/store';

const { grayList } = useGrayscaleStore();

import { QfeiIconViewOutlined, QfeiIconCloseOneOutlined } from '@qfei-design/icons-vue';
const props = defineProps({
  fileItem: {
    //文件
    type: Object
  },
  fieldExt: {
    type: [Object, String],
    default: () => {}
  },
  showRemoveBtn: {
    //是否显示删除按钮
    type: Boolean,
    default: true
  }
});
const iconStyle = {
  width: '60px',
  height: '60px'
};
const previewModalRef = ref(null);
const emits = defineEmits(['cb']);
const getFileList = ref(props.fileItem || []);
watch(
  () => props.fileItem,
  (val) => {
    getFileList.value = val || [];
  }
);

const fileList = computed(() => {
  return getFileList.value?.filter((item) => item != null);
});
// 文件类型判断
const fileType = (getFileItem, type) => {
  return getFileType(getFileItem?.name || '', type);
};
const setLink = (fileItem) => {
  return grayList?.['FilePreview:preview'] || (!fileType(fileItem, 'img') && !fileType(fileItem, 'video') && !fileType(fileItem, 'pdf')) ? setUrl(fileItem, 0) : 'javascript:void(0)';
};
const setTarget = (fileItem) => {
  return grayList?.['FilePreview:preview'] || (!fileType(fileItem, 'img') && !fileType(fileItem, 'video') && !fileType(fileItem, 'pdf')) ? '_blank' : '_self';
};
//下载
const handleDownload = (item) => {
  const getFilePath = setUrl(item, 1);
  downloadFile(getFilePath, item.name);
};
const fieldExt = computed(() => {
  if (tools.isJSON(props.fieldExt)) {
    return JSON.parse(props.fieldExt);
  }
  return props?.fieldExt || {};
});

const deleteImg = (item) => {
  const index = getFileList.value.findIndex((file) => file.url === item.url);
  if (index > -1) {
    getFileList.value.splice(index, 1);
    const newFile = getFileList.value?.map((item) => {
      item['default'] = true;
    });

    emits('cb', [...(Array.isArray(newFile) ? newFile : [])]);
  }
};

const visible = ref(false);
const getFileItem = ref(null);
const getFileIndex = ref(0);
//打开弹窗预览
const openPreview = (fileItem, index) => {
  // 众行互动不展示预览
  if (grayList?.['FilePreview:preview']) return;
  if (!checkInvalidUrl(fileItem)) return;
  if (!fileType(fileItem, 'img') && !fileType(fileItem, 'video') && !fileType(fileItem, 'pdf')) return;
  visible.value = true;
  getFileItem.value = fileItem;
  getFileIndex.value = index;
  nextTick(() => {
    previewModalRef.value?.openPreviewModal({
      index: getFileIndex.value
    });
  });
};
</script>
<style scoped lang="less">
@import './fh-attachment-watermark.less';
</style>
